<ui-input-wrapper
  [label]="base.label"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [randomInputId]="randomInputId"
  [labelTemplate]="base.labelTemplate"
  [errors]="ngControl.control.errors"
  [submitted]="submitted"
  [control]="innerControl"
  [errorLabels]="base.errorLabels()">
  <p-datepicker
    #calendarRef
    class="flex w-full"
    [showIcon]="true"
    [inputId]="randomInputId"
    placeholder="Vyberte"
    [appendTo]="dropdown.appendTo()"
    [showOnFocus]="false"
    (onSelect)="fireHandleChange($event)"
    (onInput)="fireControlChange()"
    (onShow)="setCorrectCalendarTopPosition()"
    (onClose)="handleOnClose()"
    (onMonthChange)="handleOnMonthChange()"
    (onClear)="fireHandleChange(null)"
    (keydown)="restrictInput($event)"
    (keydown.enter)="handleOnEnter($event)"
    [showTime]="datePicker.showTime()"
    [showClear]="true"
    [minDate]="datePicker.minDate()"
    [timeOnly]="datePicker.timeOnly()"
    [baseZIndex]="10000"
    [firstDayOfWeek]="1"
    [panelStyle]="panelStyle()"
    [panelStyleClass]="dropdown.panelStyleClass()"
    [dateFormat]="datePicker.dateFormat()"
    [formControl]="innerControl">
  </p-datepicker>
</ui-input-wrapper>
